import { render } from "./yeji.vue?vue&type=template&id=0810fbca&scoped=true"
import script from "./yeji.vue?vue&type=script&lang=js"
export * from "./yeji.vue?vue&type=script&lang=js"

import "./yeji.vue?vue&type=style&index=0&id=0810fbca&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0810fbca"]])

export default __exports__